import { Dispatch, ThunkAction } from '../../../types/actions';
import { IGetState, TListId } from '../../../types/types';
import { TStatus } from '../../../types/model';
import { listPatchRest } from './api/helpers/listPatchRest';
import { ISorting } from '../../../store/model/list/types';

export const listSetSorting = (
    listId: TListId,
    sorting: ISorting
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(listPatchRest(listId, {sorting}));
    };
    return action;
}
